<template>
  <div class="helpaccordion">
      <div class="py-0" :class="titlesize">
          <a
            role="button"
            tabindex="0"
            :aria-expanded="active ? 'true' : 'false'"
            :aria-label="label ? label : title"
            class="cursor-pointer tab__link p-0 no-underline flex content-center items-center pr-2"
            @click.prevent="toggleAccordion"
            @keydown.enter.stop.prevent="toggleAccordion"
            @keydown.space.stop.prevent="toggleAccordion"
          >
              <div class="pl-1"><i aria-hidden="true" class="material-icons leading-tight text-sm">{{ icon }}</i></div>

              <div class="font-bold flex-1 px-3 uppercase">{{ title }}</div>

              <span class="pl-3 leading-tight print:hidden" v-show="!active"><i aria-hidden="true" class="material-icons leading-tight text-base p-0">expand_more</i></span>

              <span class="pl-3 text-block text-red-800" v-show="active"><i aria-hidden="true" class="material-icons leading-tight">cancel</i></span>
          </a>
      </div>

      <div class="helpaccordion-content" v-show="active">
        <slot />
      </div>            
  </div>
</template>
}
<script>
export default {

  props: {
    label: '',
    title: '',
    icon: '', 
    description: '',
    titlesize: {
      default: 'text-xxs',
    },
  },

  data () {
    return {
        active: false,
    }
  },

  methods: {
    toggleAccordion() {
      this.active = ! this.active;
    },
  },
}
</script>
